import React, { useEffect, useRef } from "react";
import "./ChatMsgs.css";
// import clientIcon from '../../../assets/clientIcon.png';
import userIcon from '../../../assets/userIcon.png';
import ChatMsg from "./ChatMsg/ChatMsg";
import ChatAgents from "./ChatAgents/ChatAgents";
import { convertDateTimeToApplicationTime } from "../../../util/functions"
import * as settings from '../../../settings'
import { Spinner } from 'react-bootstrap';
import ChatAttachments from "./ChatAttachments/ChatAttachments";

const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV
//import Spinner from '../../UI/Spinner/Spinner'
//<img alt='Cant load img' src={this.props.avatarImg  ? serverUrl + `/users/${this.props.userId}/avatar` : userIcon } onError={(event) => { event.target.onerror = null; event.target.src = userIcon }} className='rounded-circle user_img_msg' />
const ChatMsgs = (props) => {//fileToSend
  const { fileToSend,onRemoveFileFromAttachmentsClicked } = props
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView({ behavior: "auto" }); //auto to fast,smooth to smooth
  };
  let allMsgs = null; //<Spinner />;

  const selectedChannel = props.selectedChannel
  const clientName = props.chatSelected
  let MsgCount = -1

  // console.log(selectedChannel)
  // console.log(clientName)
  if (props.loadingMsg) {
    allMsgs = <div className='chat-msgs-spinner-container'>
      <Spinner animation="border" className='chat-msgs-spinner' />
    </div>
  }
  else {
    const usersAvatarObj = {}

    allMsgs = props.msgs.map((msg, i) => {
      let senderName = null;
      if (msg.isAgent) {
        senderName = msg.userId?.name ? msg.userId.name : msg.agentName;
        if (msg.userId?.avatar) {//if that agent has avatar
          const userImgElement = usersAvatarObj[msg.userId._id]
          if (!userImgElement) {//if agent not already added
            usersAvatarObj[msg.userId._id] = <img alt='Cant load img' src={serverUrl + `/users/${msg.userId._id}/avatar`} onError={(event) => { event.target.onerror = null; event.target.src = userIcon }} className='rounded-circle user_img_msg' />
          }
        }
      } else {
        senderName = msg.clientName;
      }
      let MsgTime = new Date(msg.msgTime);
      let formatted_date = convertDateTimeToApplicationTime(MsgTime)

      return (
        <ChatMsg
          avatarImgElement={msg.userId?._id && usersAvatarObj[msg.userId._id]}
          selectedChannel={props.selectedChannel}
          loggedNowAgent={props.loggedNowAgent}
          key={msg._id}
          msgId={msg._id}
          msgSubject={msg.msgSubject}
          msgMails={msg.msgMails}
          msgCC={msg.msgCC}
          msgBCC={msg.msgBCC}
          msg={msg.msg}
          msgStyle={msg.style}
          selectedChatCrmContact={props.selectedConv ? props.selectedConv.crmId : undefined}
          file={msg.mediaUrl}
          replyToMsg={msg.replyToMsg}
          time={formatted_date}
          isAgent={msg.isAgent}
          senderName={senderName}
          readStatus={msg.msgStatus}
          displayName={msg.displayName}
          onReplyActionSelected={() => props.onMsgActionSelected(msg, 'REPLY')}
          onForwardActionSelected={() => props.onMsgActionSelected(msg, 'FORWARD')}
          onReplyAllActionSelected={() => props.onMsgActionSelected(msg, 'REPLY_ALL')}
          onForwardToOtherChannelSelected={((clientName, msgType) => props.onMsgActionSelected(msg, 'FORWARD_TO_OTHER_CHANNEL', { forwardToChannel: msgType, forwardToClientName: clientName }))}
          selectedMsg={props.selectedMsg}
          selectedMsgAction={props.selectedMsgAction}
          isLastMsg={i === 0}
          onFetchMoreChatMsgsClicked={props.onFetchMoreChatMsgsClicked}
          areMoreMsgToLoad={props.areMoreMsgToLoad}
          msgObj={msg}
          contact={props.selectedConv?.contactId}
          mediaTokenData={props.mediaTokenData}
        />
      );
    });
  }
  if (allMsgs) {
    MsgCount = allMsgs.length - props.loadedMsgFromPagingCount
  }

  useEffect(scrollToBottom, [selectedChannel, clientName, MsgCount]);//[MsgCount] loadedMsgFromPagingCount

  let listOfChatAgents = undefined;
  if (props.selectedConv) {
    listOfChatAgents = props.selectedConv.agentName.map((agentName) => {
      const isOnline = props.listOfOnlineAgents.some(
        (OnlineAgent) => OnlineAgent.agentName === agentName.agent
      );
      // let fullAgentData = props.companyAgents.find(agent => agent.agentName === agentName.agent)
      // if (!fullAgentData) fullAgentData = { agentName: undefined }
      const seenAgent = props.selectedConv.agentSeenCount.find(agentItem => agentItem.agent === agentName.agent)
      let agentSeenCount = 0
      if (seenAgent) agentSeenCount = seenAgent.seen
      const notSeenCount = props.selectedConv.notSeenCount - agentSeenCount
      return (
        <ChatAgents
          key={agentName.agent}
          userId={agentName.userId?._id}
          avatarImg={agentName.userId?.avatar}
          loggedNowAgent={props.loggedNowAgent}
          agentName={agentName.agent}
          name={agentName?.userId?.name}
          isOnline={isOnline}
          notSeenCount={notSeenCount}
        />

      );
    });
  }
  let mainAllMsgChatDiv = 'col-12 inChatAllMsgs'
  if (listOfChatAgents && listOfChatAgents.length > 0) {
    mainAllMsgChatDiv = 'col-11 inChatAllMsgs'
  }

  const isAttachments = !!fileToSend?.length

  return (
    <>
      <div className={`row inchat ${props.selectedChannel === 'mail' && 'in-chat--email'} ${isAttachments && 'chat-high-minus--attachment'}`}>
        <div className={`${mainAllMsgChatDiv} col--no-padding`}>
          <div className="chatSection">
            <div className="card-body msg_card_body overflow-auto">
              {allMsgs}
            </div>
            <div ref={messagesEndRef} />
          </div>
        </div>
        {
          listOfChatAgents && listOfChatAgents.length > 0 ?
            (
              <div className="col-1 inChatSideAgentWindow">{listOfChatAgents}</div>
            )
            : null
        }
      </div>
      {isAttachments &&
        <div className={`row chat-attachments-row`}>
          <div className={`col-12 col--no-padding`}>
            <ChatAttachments onRemoveFileFromAttachmentsClicked={onRemoveFileFromAttachmentsClicked} fileToSend={fileToSend}/>
          </div>
        </div>
      }
    </>
  );
};

export default ChatMsgs;
